import { ReactorParams } from '../class/element/ship/reactor';
import { ShipParams } from '../class/element/ship/ship';
import { WeaponParams } from '../class/element/ship/weapon';

import * as spriteConfig from './sprites.config';
import * as weaponConfig from './weapons.config';
import * as reactorConfig from './reactors.config'

export const basicJet: ShipParams = {
  width: 164 / 6,
  height: 241 / 6,
  moveSpeed: 500,
  accelerationSpeed: 500,
  HP: 100,
  spriteParams: { ...spriteConfig.ships.basicJet },
  weaponParamsArray: [
    /* 2 front guns */
    {
      ...weaponConfig.jetCannon,
      angleFromShipCenter: 190,
      distanceFromShipCenter: 8,
      lookAngle: 90,
    },
    {
      ...weaponConfig.jetCannon,
      angleFromShipCenter: 350,
      distanceFromShipCenter: 8,
      lookAngle: 90,
      soundParams: undefined
    },
  ] as WeaponParams[],
  reactorParamsArray: [
    {
      ...reactorConfig.basicJetReactor,
      angleFromShipCenter: 270 - 12,
      distanceFromShipCenter: 15,
    },
    {
      ...reactorConfig.basicJetReactor,
      angleFromShipCenter: 270 + 12,
      distanceFromShipCenter: 15,
    }
  ] as ReactorParams[],
};

export const destroyer: ShipParams = {
  HP: 1000,
  width: 662 / 3,
  height: 1022 / 3,
  moveSpeed: 200,
  lookSpeed: 30,
  accelerationSpeed: 150,
  decelerationSpeed: 300,
  canStrafe: false,
  spriteParams: { ...spriteConfig.ships.destroyer },
  weaponParamsArray: [
    /* 4 Front guns */
    {
      ...weaponConfig.destroyerCannon,
      distanceFromShipCenter: 210,
      lookAngle: 88,
      angleFromShipCenter: 95,
    },
    {
      ...weaponConfig.destroyerCannon,
      distanceFromShipCenter: 210,
      lookAngle: 92,
      angleFromShipCenter: 85,
    },
    {
      ...weaponConfig.destroyerCannon,
      lookAngle: 88,
      distanceFromShipCenter: 180,
      angleFromShipCenter: 100,
    },
    {
      ...weaponConfig.destroyerCannon,
      lookAngle: 92,
      distanceFromShipCenter: 180,
      angleFromShipCenter: 80,
    },
    /* 1 Turret each side */
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 0,
      distanceFromShipCenter: 80,
      lookAngle: 0,
    },
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 180,
      distanceFromShipCenter: 80,
      lookAngle: 180
    },
  ] as WeaponParams[],
};

export const turretDestroyer: ShipParams =
{
  ...destroyer,
  weaponParamsArray: [
    /* 4 Front guns */
    {
      ...weaponConfig.destroyerCannon,
      distanceFromShipCenter: 210,
      lookAngle: 88,
      angleFromShipCenter: 95,
    },
    {
      ...weaponConfig.destroyerCannon,
      distanceFromShipCenter: 210,
      lookAngle: 92,
      angleFromShipCenter: 85,
    },
    {
      ...weaponConfig.destroyerCannon,
      lookAngle: 88,
      distanceFromShipCenter: 180,
      angleFromShipCenter: 100,
    },
    {
      ...weaponConfig.destroyerCannon,
      lookAngle: 92,
      distanceFromShipCenter: 180,
      angleFromShipCenter: 80,
    },
    /* 3 CANONS each side */
    // left
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 0,
      distanceFromShipCenter: 80,
      lookAngle: 0,
    },
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 330,
      distanceFromShipCenter: 80,
      lookAngle: 0,
    },
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 30,
      distanceFromShipCenter: 80,
      lookAngle: 0,
    },
    //right
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 180,
      distanceFromShipCenter: 80,
      lookAngle: 180,
    },
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 150,
      distanceFromShipCenter: 80,
      lookAngle: 180,
    },
    {
      ...weaponConfig.destroyerTurret,
      angleFromShipCenter: 210,
      distanceFromShipCenter: 80,
      lookAngle: 180,
    },
    /* 2 turrets on the back */
    {
      ...weaponConfig.destroyerTurret,
      distanceFromShipCenter: 210,
      lookAngle: 270,
      angleFromShipCenter: 270 - 30,
    },
    {
      ...weaponConfig.destroyerTurret,
      distanceFromShipCenter: 210,
      lookAngle: 270,
      angleFromShipCenter: 270 + 30,
    },
  ] as WeaponParams[],
};
